import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioOptionsComponent } from './radio-options/radio-options.component';
import { SelectComponent } from './select/select.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormFieldComponent } from './form-field/form-field.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';

@NgModule({
  declarations: [
    RadioOptionsComponent,
    SelectComponent,
    FormFieldComponent,
    FormErrorComponent,
    MultiSelectComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule
  ],
  exports: [
    RadioOptionsComponent,
    SelectComponent,
    FormFieldComponent,
    FormErrorComponent,
    MultiSelectComponent
  ],
})
export class FormComponentsModule { }
